import React, { useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

export interface T05SiteNavBrandProps {
  productLabel: string;
  onAfterClick?: () => void;
}

/** Scroll to top on `/` (clears hash); from product routes navigate home then scroll. */
export function useT05HomeLinkClick(onAfterClick?: () => void) {
  const location = useLocation();
  const navigate = useNavigate();

  return useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      onAfterClick?.();

      if (location.pathname === '/') {
        e.preventDefault();
        if (location.hash) {
          window.history.replaceState(null, '', '/');
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      e.preventDefault();
      navigate('/');
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    [location.pathname, location.hash, navigate, onAfterClick],
  );
}

export const T05SiteNavBrand: React.FC<T05SiteNavBrandProps> = ({
  productLabel,
  onAfterClick,
}) => {
  const handleClick = useT05HomeLinkClick(onAfterClick);

  return (
    <Link to="/" className="t05-nav__brand" onClick={handleClick}>
      <span className="t05-nav__mark">
        <img src="/arkorbit-wappen-transparent.png" alt="" width={2560} height={1428} />
      </span>
      ARKORBIT
      <span className="t05-nav__product">{productLabel}</span>
    </Link>
  );
};
